module.exports = __webpack_public_path__ + "img/viande.592bfcb7.png";